import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card";
import SummaryHeader from "components/header/SummaryHeader";
import SearchFilter from "components/search/SearchFilter";
import SelectOption from "components/select/SelectOption";
import LeaveRequestTab from "./components/LeaveRequestTab";
import {
  getLeaveStat, getLeaveList
} from "../../../../redux/leave/leaveState";
import { getLeaveTypeList } from "../../../../redux/optionlist/optionlistState";

const LeaveRequests = ({
  pagination,
}) => {
  const dispatch = useDispatch();

  const recordStat = useSelector((state) => state.leave.leaveStat.data);
  const leaveTypeList = useSelector((state) => state.optionlist.leaveTypeList?.items);
  const filters = useSelector((state) => state.leave.leaveList.filters);
  const currentType = filters.type_id;

  const getStats = (data) => dispatch(getLeaveStat(data));
  const doSearch = (filters) => dispatch(getLeaveList(filters));

  useEffect(() => {
    dispatch(getLeaveStat());
    dispatch(getLeaveTypeList());
  }, [dispatch]);

  const onSearchType = (value) => {
    const data = {
      ...(filters || {}),
      page: 1,
			paginate: pagination?.per_page || 10,
    }

    if (value !== "all") {
      data.type_id = value;
    } else {
      delete data.type_id;
    }

    doSearchHandler(data);
  };

  const doSearchHandler = (data) => {
    doSearch(data);
    getStats(data);
  };

  return (
    <div className="flex flex-col">
      <div className="space-y-6 max-w-[1800px]">
        <SummaryHeader
          title="Leave Request Management"
          iconName="FileText"
          description="Review and manage employee leave requests"
          color="green"
          rightNav={
            <div className="flex items-center gap-6 flex-shrink-0">
              <div className="text-right">
                <p className="text-emerald-100/80 text-[12px] mb-1">
                  Pending Requests
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" />
                  <p className="text-[28px] font-bold text-white">{recordStat?.pending}</p>
                </div>
              </div>
            </div>
          }
        />

        <Card className="rounded-xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <SearchFilter
              placeholder="Search by name, ID, or position..."
              searchHandler={doSearchHandler} 
              filters={filters} 
              pagination={pagination}
            />
            <SelectOption
              placeholder="All Leave Types"
              options={leaveTypeList}
              value={currentType}
              onChange={(value) => onSearchType(value)}
            />
          </div>
        </Card>

        <LeaveRequestTab />
      </div>
    </div>
  );
};

export default LeaveRequests;
